import SeoHead from "@/Component/Seo/SeoHead";
import Deals from "@/Component/Module/Deals";
import {
  serverFetchDeals,
  serverFetchDealsModuleData,
  serverFetchReviewsList,
} from "@/services/server";
import { getCountryFromContext } from "@/utils/getCountryFromRequest";
import { fetchPageSeo } from "@/utils/pageSeo";

export default function DealsPage({
  seo,
  seoCountry,
  initialDeals,
  initialModuleData,
  initialReviewsList,
}) {
  return (
    <>
      <SeoHead seo={seo} country={seoCountry} fallbackTitle="Deals | Next Holidays" />
      <Deals
        initialDeals={initialDeals}
        initialModuleData={initialModuleData}
        initialReviewsList={initialReviewsList}
      />
    </>
  );
}

export async function getServerSideProps(context) {
  const country = getCountryFromContext(context);
  const isIndia = country === "IN";
  const initialModuleName = "Holiday";
  const seoResult = await fetchPageSeo(context);
  if (seoResult.redirect) return seoResult;

  try {
    const [dealsResponse, moduleResponse, reviewsResponse] = await Promise.all([
      serverFetchDeals(country),
      serverFetchDealsModuleData(initialModuleName, country),
      serverFetchReviewsList({ moduleType: "Deals" }, country),
    ]);

    const services = dealsResponse?.data?.services || [];
    const hasHoliday = services.some((item) => item.moduleName === "Holiday");
    const moduleName =
      isIndia || !hasHoliday
        ? services[0]?.moduleName || initialModuleName
        : initialModuleName;

    let moduleData = Array.isArray(moduleResponse?.data) ? moduleResponse.data : [];

    if (moduleName !== initialModuleName) {
      const altModuleResponse = await serverFetchDealsModuleData(moduleName, country);
      moduleData = Array.isArray(altModuleResponse?.data) ? altModuleResponse.data : [];
    }

    return {
      props: {
        seo: seoResult.seo,
        seoCountry: seoResult.seoCountry,
        initialDeals: dealsResponse?.data || null,
        initialModuleData: moduleData,
        initialReviewsList: reviewsResponse?.data || null,
      },
    };
  } catch (error) {
    console.error("Deals page SSR error:", error);
    return {
      props: {
        seo: seoResult.seo,
        seoCountry: seoResult.seoCountry,
        initialDeals: null,
        initialModuleData: [],
        initialReviewsList: null,
      },
    };
  }
}
